import React, {ReactNode} from 'react';
import {Button, Icon, ViewIntent} from '@mc/ui-v4';
import classNames from 'classnames';
import {IconProp, SizeProp} from '@fortawesome/fontawesome-svg-core';

type Props = {
    classname?: string;
    icon?: IconProp;
    title?: string;
    tooltip?: string;
    onClick: () => void;
    active?: boolean;
    colorEdge?: boolean;
    vertical?: boolean;
    disabled?: boolean;
    intent?: ViewIntent;
    children?: ReactNode;
    size?: SizeProp;
};

export const ToolbarButton: React.FC<Props> = ({
    size,
    intent = 'primary',
    classname,
    onClick,
    title,
    tooltip,
    icon,
    active,
    vertical,
    disabled,
    colorEdge,
    children,
}) => {
    const toolTooltip = title ?? tooltip;

    return (
        <>
            {vertical ? (
                <Button
                    disabled={disabled}
                    inheritColor
                    style={'link'}
                    tooltip={toolTooltip}
                    className={classNames('toolbar-button vertical', classname, {['active']: active})}
                    onClick={onClick}
                >
                    <div className={'d-flex flex-column align-items-center'}>
                        <Icon intent={disabled ? 'inactive' : intent} icon={icon} size={size} />
                    </div>
                </Button>
            ) : (
                <Button
                    disabled={disabled}
                    inheritColor
                    style={'link'}
                    className={classNames('toolbar-button link-color', classname, {
                        ['active']: active,
                        ['align-left']: Boolean(children),
                        ['color-edge']: Boolean(colorEdge),
                    })}
                    tooltip={toolTooltip}
                    onClick={onClick}
                    icon={<Icon intent={disabled ? 'inactive' : intent} icon={icon} size={size} />}
                >
                    {children}
                </Button>
            )}
        </>
    );
};
